import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {NotificationsPermissionClickEvent} from "../models/events/notifications-permission.click-event";
import {ACTION_TYPES} from "../consts";

export class NotificationsPermissionClickEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.notificationsPermissionClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = NotificationsPermissionClickEvent;
  }
}
